<template>
<div class="wrapper">
<div class="row row-wider">
<div class="col-md-12" style="min-height: 150px;">
<tabs nav-style="tabs" v-model="activeTabIndex">
    <tab header="Recording" :disabled="disableRecording">
        <projectHeader v-show="project" v-bind:project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <loader v-if="culturalResourceRecordingLoading"/>
        <form v-if="!culturalResourceRecordingLoading" @submit.prevent="submit" class="form" id="sticky">
            <div class="container">
                <fieldset :disabled="formDisabled">
                    <div class="sticky" v-if="!isSegment">
                        <ul>
                            <li><a href="#overview">Overview</a></li>
                            <li><a href="#location">Location</a></li>
                            <li><a href="#nationalRegisterStatus">Register Status</a></li>
                            <li><a href="#investigativeHistory">Investigative History</a></li>
                            <li><a href="#propertyDescription">Property Description</a></li>
                            <li><a href="#siteSetting">Site Setting</a></li>
                        </ul>
                    </div>
                </fieldset>
                <fieldset :disabled="!isShpoCrApprovingUser && formDisabled">
                    <div class="panel panel-offset" id="overview">
                        <div class="panel-heading green-bg">
                            <h3 class="panel-title">Overview</h3>
                        </div>
                        <div class="panel-body">
                            <identificationForm ref="identificationForm" :style="identificationStyle" :culturalResourceRecording="culturalResourceRecording" :culturalResource="culturalResource"
                            :formDisabled="formComponentDisabled.identification" :isShpoCr="isShpoCr" :otherCrrList="otherCrrList" :qaqcEnabled="false" :attachmentString="attachmentString"
                            :recordingOrganization="project.fieldOrgDescription" :isShpoCrApprovingUser="isShpoCrApprovingUser" source='CulturalResourceRecording'></identificationForm>
                        </div>
                    </div>
                </fieldset>
                <fieldset :disabled="formDisabled">
                    <div class="panel panel-offset" id="location" v-if="!isSegment">
                        <div class="panel-heading green-bg">
                            <h3 class="panel-title">Location</h3>
                        </div>
                        <div class="panel-body">
                            <locationForm ref="locationForm" :style="locationStyle" :formDisabled="formComponentDisabled.location" :qaqcEnabled="false"
                                :crrId="culturalResourceRecordingId" :siteTrsList="siteTrsList" ></locationForm>
                        </div>
                    </div>

                    <div class="panel panel-offset" v-bind:style="nationalRegisterStatusStyle" id="nationalRegisterStatus" v-if="!isSegment">
                        <div class="panel-heading green-bg">
                            <h3 class="panel-title">National Register Status</h3>
                        </div>
                        <div class="panel-body">
                            <fieldset :disabled="formComponentDisabled.nationalRegister">
                                <nationalRegisterStatusForm :isConditionReport="isConditionReport" :formDisabled="formComponentDisabled.nationalRegister"
                                :qaqcEnabled="false" :crrId="culturalResourceRecordingId"></nationalRegisterStatusForm>
                            </fieldset>
                        </div>
                    </div>

                    <div class="panel panel-offset" v-bind:style="investigativeHistoryStyle" name="inventoryHistoryPanel" id="investigativeHistory" v-if="!isSegment">
                        <div class="panel-heading green-bg">
                            <h3 class="panel-title">Investigative History</h3>
                        </div>
                        <div class="panel-body">
                            <fieldset :disabled="formComponentDisabled.investigativeHistory">
                                <investigativeHistoryForm :formDisabled="formComponentDisabled.investigativeHistory" :qaqcEnabled="false" :crrId="culturalResourceRecordingId"></investigativeHistoryForm>
                            </fieldset>
                        </div>
                    </div>

                    <div class="panel panel-offset" v-bind:style="propertyDescriptionStyle" id="propertyDescription" v-if="!isSegment">
                        <div class="panel-heading green-bg">
                            <h3 class="panel-title">Property Description</h3>
                        </div>
                        <div class="panel-body">
                            <fieldset :disabled="formComponentDisabled.propertyDescription">
                                <propertyDescriptionForm :formDisabled="formComponentDisabled.propertyDescription" :qaqcEnabled="false" :crrId="culturalResourceRecordingId"></propertyDescriptionForm>
                            </fieldset>
                        </div>
                    </div>

                    <div class="panel panel-offset" v-bind:style="siteSettingStyle" name="siteSettingPanel" id="siteSetting" v-if="!isSegment">
                        <div class="panel-heading green-bg">
                            <h3 class="panel-title">Site Setting</h3>
                        </div>
                        <div class="panel-body">
                            <fieldset :disabled="formComponentDisabled.siteSetting">
                                <siteSettingForm :formDisabled="formComponentDisabled.siteSetting" :qaqcEnabled="false" :crrId="culturalResourceRecordingId"></siteSettingForm>
                            </fieldset>
                        </div>
                    </div>
                </fieldset>
            </div>
        </form>
    </tab>
    <tab v-if="culturalResourceRecording.siteTypeId !== propertyTypeEnum.Building" :header="isConditionReport ? 'Condition Narrative' : 'Site Narrative'" :disabled="isInternalReview">
        <projectHeader v-show="project" v-bind:project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :currentEval="currentEval"></siteHeader>
        <fieldset :disabled="formDisabled">
            <form v-if="!culturalResourceRecordingLoading" @submit.prevent="submit" class="form">
                <div class="panel panel-offset" id="siteNarrative">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">{{isConditionReport ? 'CONDITION NARRATIVE' : 'SITE NARRATIVE'}}</h3>
                    </div>
                    <div class="panel-body">
                        <div class="form-group">
                            <label class="col-md-2 control-label">DESCRIPTION</label>
                            <div class="col-md-10" v-if="formDisabled">
                                <div v-html="culturalResourceRecording.siteNarrative" class="form-control" style="height: auto;"></div>
                            </div>
                            <div class="col-md-10" v-else>
                                <!-- <textarea class="form-control" rows="15" v-model="culturalResourceRecording.siteNarrative"/> -->
                                <editor id="editorSiteNarrative" v-model="culturalResourceRecording.siteNarrative" :init="editor.options"></editor>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2" v-if="!formDisabled">
                                <button class="btn btn-primary pull-right" v-on:click="saveSiteNarrative">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </fieldset>
    </tab>
    <tab v-if="culturalResourceRecording.siteTypeId == propertyTypeEnum.Building" header="Property Desc./History" :disabled="isInternalReview">
        <projectHeader v-show="project" v-bind:project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :currentEval="currentEval"></siteHeader>
        <fieldset :disabled="formDisabled">
            <form v-if="!culturalResourceRecordingLoading" @submit.prevent="submit" class="form">
                <div class="panel panel-offset" id="siteNarrative">
                    <div class="panel-heading green-bg">
                        <h3 class="panel-title">PROPERTY DESCRIPTION/HISTORY</h3>
                    </div>
                    <div class="panel-body">
                        <div class="form-group">
                            <label class="col-md-2 control-label">PROPERTY DESCRIPTION</label>
                            <div class="col-md-10" v-if="formDisabled">
                                <div v-html="culturalResourceRecording.buildingDescription" class="form-control" style="height: auto;"></div>
                                <textarea class="form-control" rows="10" v-model="culturalResourceRecording.buildingDescription"/>
                            </div>
                            <div class="col-md-10" v-else>
                                <editor id="editorBuildingDesc" v-model="culturalResourceRecording.buildingDescription" :init="editor.options"></editor>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">PROPERTY HISTORY</label>
                            <div class="col-md-10" v-if="formDisabled">
                                <div v-html="culturalResourceRecording.buildingHistory" class="form-control" style="height: auto;"></div>
                                <!-- <textarea class="form-control" rows="10" v-model="culturalResourceRecording.buildingHistory"/> -->
                            </div>
                            <div class="col-md-10" v-else>
                                <editor id="editorBuildingHist" v-model="culturalResourceRecording.buildingHistory" :init="editor.options"></editor>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2" v-if="!formDisabled">
                                <button class="btn btn-primary pull-right" v-on:click="saveSiteNarrative">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </fieldset>
    </tab>
    <tab header="Map" :disabled="culturalResourceRecordingLoading" v-if="!isRestrictedRole" >
        <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :currentEval="currentEval"></siteHeader>
        <mapx ref="mapx" :mediaTypeId="mediaTypeId" :parentId="culturalResourceRecordingId" :loadOnMount="false" :smithsonianNo="smithsonianNoForMap"
            :crrShowShapefile="isFirstOrFullRerecord" ></mapx>
    </tab>
    <tab header="Documents" :disabled="isInternalReview">
        <projectHeader v-show="project" v-bind:project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :currentEval="currentEval"></siteHeader>
        <siteFormDocuments ref="siteFormDocuments" :formDisabled="formDisabled && !qaqcEnabled" :loadOnMount="false"></siteFormDocuments>
        <div style="margin-top: 20px;">
            <hr />
            <mediaLetter ref="mediaLetter" :parentId="culturalResourceRecordingId" :mediaTypeId="mediaTypeIdCrrLetter" :loadOnMount="false"></mediaLetter>
        </div>
    </tab>
    <tab :disabled="isConditionReport || isSiteLead || isInternalReview" header="Attachments">
        <projectHeader v-show="project" v-bind:project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :currentEval="currentEval"></siteHeader>
        <attachments
            ref="attachments" :formDisabled="formDisabled" :qaqcEnabled="false" :crrId="culturalResourceRecordingId"
            :loadOnMount="true" :projectId="project.projectId" v-bind:attachments.sync="attachmentString">
        </attachments>
    </tab>
    <tab header="Eligibility/Submission">
        <projectHeader v-show="project" v-bind:project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :currentEval="currentEval"></siteHeader>
        <div style="margin-top: 20px;">
            <siteFormEligibility id="eligibility" ref="eligibility" :isConditionReport="isConditionReport" :isInternalReview="isInternalReview" :culturalResourceRecording="culturalResourceRecording" :culturalResource="culturalResource"
            v-on:workflowLoaded="setWorkflowLoaded" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess" :hasAgencyAccess="hasAgencyAccess" :hasShpoAccess="hasShpoAccess" :isNormalization="isNormalization" ></siteFormEligibility>
        </div>
        <div v-if="isShpo" style="margin-top: 20px;">
            <quickLetter :projectId="project.projectId" :investigationId="investigation.investigationId" :culturalResourceRecordingId="culturalResourceRecordingId"
            :parentId="culturalResourceRecordingId" :mediaTypeId="mediaTypeIdCrrLetter"></quickLetter>
        </div>
        <div v-if="culturalResourceRecordingId">
            <button :disabled="reportLoading" name="siteFormReport" class="btn btn-primary" v-on:click="genSiteFormReport">Generate Site Form Report</button>
        </div>
    </tab>
    <tab v-if="qaqcEnabled" header="QA/QC">
        <projectHeader v-show="project" v-bind:project="project"></projectHeader>
        <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
        <siteHeader v-show="culturalResource" :culturalResource="culturalResource" :siteName="culturalResourceRecording.siteName" :currentEval="currentEval"></siteHeader>
        <qaqcCulturalResourceRecording ref="qaqc" :culturalResource="culturalResource" :loadOnMount="false"></qaqcCulturalResourceRecording>
    </tab>
</tabs>
</div>
</div>
<div v-if="isDebug">
    <div>
        <h3 class="text-danger">****** Debug ******</h3>
    </div>
    <div>
    </div>
</div>
</div>
</template>

<script>

import loggingService from '../services/util/loggingService'
import culturalResourceService from '../services/culturalResourceService'
import culturalResourceRecordingService from '../services/culturalResourceRecordingService'
import workflowService from '../services/workflowService'
import investigationService from '../services/investigationService'
import projectService from '../services/projectService'
import workflow from '../components/Workflow.vue'
import loader from '../components/Loader.vue'
import identificationForm from '../components/SiteForm/IdentificationForm.vue'
import locationForm from '../components/SiteForm/LocationForm.vue'
import nationalRegisterStatusForm from '../components/SiteForm/NationalRegisterStatusForm.vue'
import investigativeHistoryForm from '../components/SiteForm/InvestigativeHistoryForm.vue'
import propertyDescriptionForm from '../components/SiteForm/PropertyDescriptionForm.vue'
import siteSettingForm from '../components/SiteForm/SiteSettingForm.vue'
import qaqcCulturalResourceRecording from '@/views/QaqcCulturalResourceRecording.vue'
import investigationHeader from '../components/InvestigationHeader.vue'
import projectHeader from '../components/ProjectHeader.vue'
import siteHeader from '../components/SiteHeader.vue'
import mediaService from '../services/mediaService'
import mapx from '@/views/MapNew'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import gisService from '@/services/gisService'
import evaluationService from '@/services/siteForm/evaluationService'
import { mapState } from 'vuex'

import siteFormEligibility from '../components/SiteForm/SiteFormEligibility.vue'
import siteFormDocuments from '../components/SiteForm/SiteFormDocuments.vue'
import attachments from '../components/SiteForm/Attachments.vue'
import mediaLetter from '../components/MediaLetter.vue'
import quickLetter from '../components/QuickLetter.vue'

import editor from '@tinymce/tinymce-vue'
import { tab, tabs } from 'vue-strap'
import _ from 'lodash/lodash.min.js'

export default {
    components: {
        tabs,
        tab,
        workflow,
        identificationForm,
        nationalRegisterStatusForm,
        investigativeHistoryForm,
        propertyDescriptionForm,
        siteSettingForm,
        loader,
        investigationHeader,
        projectHeader,
        locationForm,
        siteFormEligibility,
        attachments,
        siteFormDocuments,
        mapx,
        qaqcCulturalResourceRecording,
        mediaLetter,
        quickLetter,
        siteHeader,
        editor
    },
    props: {
        startAtTabIndex: { default: 0 }
    },
    computed: {
        culturalResourceRecordingWorkflowId: function () {
            return workflowService.WorkflowEnum.CulturalResourceRecording
        },
        isConditionReport: function () {
            return this.culturalResourceRecording.recordingTypeId === this.recordingTypeEnum.ConditionReport
        },
        isInternalReview: function () {
            return this.culturalResourceRecording.recordingTypeId === this.recordingTypeEnum.InternalReview
        },
        isFirstOrFullRerecord: function () {
            return this.culturalResourceRecording.recordingTypeId === this.recordingTypeEnum.FirstRecording ||
                this.culturalResourceRecording.recordingTypeId === this.recordingTypeEnum.FullRerecord
        },
        isSiteLead: function () {
            return this.culturalResourceRecording.recordingTypeId === this.recordingTypeEnum.SiteLead
        },
        isNormalization: function () {
            return +this.culturalResourceRecording.recordingTypeId === +this.recordingTypeEnum.Normalization
        },
        identificationStyle: function () {
            switch (this.culturalResourceRecording.recordingTypeId) {
            case this.recordingTypeEnum.SiteLead:
                return {}
                //return this.disabledStyle
            default:
                return {}
            }
        },
        locationStyle: function () {
            switch (this.culturalResourceRecording.recordingTypeId) {
            case this.recordingTypeEnum.SiteLead:
                return this.disabledStyle
            default:
                return {}
            }
        },
        nationalRegisterStatusStyle: function () {
            loggingService.log(this.isDebug, 'Cultural Property Form', `NR style reportingType: ${this.culturalResourceRecording.recordingTypeId}, propertyType: ${this.culturalResource.siteTypeId}, time period: ${this.culturalResource.timePeriodId}`)
            switch (this.culturalResourceRecording.recordingTypeId) {
            case this.recordingTypeEnum.SiteLead:
                loggingService.log(this.isDebug, 'Cultural Property Form', `disabled because site lead`)
                return this.disabledStyle
            default:
                return {}
            }
        },
        investigativeHistoryStyle: function () {
            loggingService.log(this.isDebug, 'Cultural Property Form', `Investigative History reportingType: ${this.culturalResourceRecording.recordingTypeId}, propertyType: ${this.culturalResource.siteTypeId}, time period: ${this.culturalResource.timePeriodId}`)
            switch (this.culturalResourceRecording.recordingTypeId) {
            case this.recordingTypeEnum.ConditionReport:
            case this.recordingTypeEnum.SiteLead:
                loggingService.log(this.isDebug, 'Cultural Property Form', `disabled because condition report, site lead`)
                return this.disabledStyle
            default:
                return {}
            }
        },
        propertyDescriptionStyle: function () {
            loggingService.log(this.isDebug, 'Cultural Property Form', `Property Description reportingType: ${this.culturalResourceRecording.recordingTypeId}, propertyType: ${this.culturalResource.siteTypeId}, time period: ${this.culturalResource.timePeriodId}`)
            switch (this.culturalResourceRecording.recordingTypeId) {
            case this.recordingTypeEnum.Update:
            case this.recordingTypeEnum.ConditionReport:
            case this.recordingTypeEnum.SiteLead:
                loggingService.log(this.isDebug, 'Cultural Property Form', `disabled because update,condition report, site lead`)
                return this.disabledStyle
            default:
                return {}
            }
        },
        siteSettingStyle: function () {
            switch (this.culturalResourceRecording.recordingTypeId) {
            case this.recordingTypeEnum.FullRerecord:
                switch (this.culturalResourceRecording.siteTypeId) {
                case culturalResourceRecordingService.PropertyTypeEnum.Building:
                case culturalResourceRecordingService.PropertyTypeEnum.Structure:
                    return this.disabledStyle
                case culturalResourceRecordingService.PropertyTypeEnum.Object:
                case culturalResourceRecordingService.PropertyTypeEnum.Landscape:
                case culturalResourceRecordingService.PropertyTypeEnum.TCP:
                    if (this.culturalResourceRecording.timePeriodId === culturalResourceRecordingService.TimePeriodEnum.Historic) {
                        return this.disabledStyle
                    }
                    break
                default:
                    return {}
                }
                break
            case this.recordingTypeEnum.Update:
            case this.recordingTypeEnum.ConditionReport:
            case this.recordingTypeEnum.SiteLead:
                return this.disabledStyle
            default:
                return {}
            }
        },
        propertyTypeEnum: function () {
            return culturalResourceRecordingService.PropertyTypeEnum
        },
        isDistrictMember: function () {
            return (this.culturalResource.grouping === 'Group Member' && !(this.culturalResource.segment))
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isAdmin: function () {
            var roleList = [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleList))
        },
        // disable forms if it's been submitted unless user has admin role, or if agency/shpo created investigation, or if it's qaqcEnabled
        formDisabled: function () {
            return !this.isAdmin && !this.hasConsultantAccess &&
                !this.hasAgencyAccess && !this.hasShpoAccess
        },
        // disabling individual form components based on recording type:
        formComponentDisabled: function () {
            return {
                identification: this.formDisabled || !(_.isEmpty(this.identificationStyle)),
                location: this.formDisabled || !(_.isEmpty(this.locationStyle)),
                nationalRegister: this.formDisabled || !(_.isEmpty(this.nationalRegisterStatusStyle)),
                investigativeHistory: this.formDisabled || !(_.isEmpty(this.investigativeHistoryStyle)),
                propertyDescription: this.formDisabled || !(_.isEmpty(this.propertyDescriptionStyle)),
                siteSetting: this.formDisabled || !(_.isEmpty(this.siteSettingStyle))
            }
        },
        hasConsultantAccess: function () {
            return !this.isSubmitted && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ConsultantUser])
        },
        hasAgencyAccess: function () {
            return (this.investigation.recordCreatedBy === 'Agency' || !this.isAgencySubmitted) &&
                (userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser]))
        },
        hasShpoAccess: function () {
            if (this.isShpo) {
                if (this.isShpoReadOnly) {
                    return this.shpoCrBacklog || this.isNormalization
                } else {
                    return (this.investigation.recordCreatedBy === 'SHPO' || this.investigation.isE106Investigation)
                }
            } else {
                return false
            }
        },
        isShpo: function () {
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList))
        },
        isShpoReadOnly: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoReadOnlyRoleList)
        },
        isShpoCr: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoCrRoleList)
        },
        shpoCrBacklog: function () {
            return this.isShpoReadOnly && this.investigation.isQaqcBacklog && !this.isQaqc
        },
        mediaTypeIdCrrLetter: function () {
            return mediaService.mediaType.CulturalResourceRecordingLetter
        },
        smithsonianNoForMap: function () {
            return this.culturalResourceRecording.smithsonianNumber
            // if (this.isFirstOrFullRerecord) {
            //     return null
            // } else {
            //     return this.culturalResourceRecording.smithsonianNumber
            // }
        },
        isShpoCrApprovingUser: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [ roleService.RoleEnum.ShpoCrApprovingUser ])
        },
        isRestrictedRole: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.RestrictedRoleList)
        }
    },
    data: function () {
        return {
            activeTabIndex: this.startAtTabIndex,
            isDebug: false,
            culturalResourceRecordingLoading: true,
            culturalResourceRecordingId: +this.$route.params.culturalResourceRecordingId,
            disabledStyle: {
                'pointer-type': 'None',
                'opacity': 0.4
            },
            investigation: {},
            project: {},
            culturalResource: {},
            culturalResourceRecording: {},
            propertyFlags: {},
            timePeriodsFlags: {},
            mediaTypeId: mediaService.mediaType.CulturalResourceShapeFile.toString(),
            tabsEnum: {
                request: 0,
                narrative: 1,
                map: 2,
                mapLoaded: false,
                documents: 3,
                documentsLoaded: false,
                attachments: 4,
                attachmentsLoaded: false,
                eligibility: 5,
                eligibilityLoaded: false,
                qaqc: 6,
                qaqcLoaded: false
            },
            qaqcEnabled: false,
            isQaqc: false,
            isSubmitted: true,
            isAgencySubmitted: true,
            isSegment: false,
            attachmentString: '',
            recordingTypeEnum: culturalResourceRecordingService.RecordingTypeEnum,
            siteTrsList: [],
            currentEval: {},
            disableRecording: false,
            reportLoading: false,
            editor: {
                options: {
                    selector: '#editor',
                    height: 500,
                    plugins: 'lists paste table',
                    oninit: 'setPlainText',
                    forced_root_block: false,
                    menubar: 'edit format',
                    toolbar: 'undo redo | fontselect fontsizeselect | bullist table',
                    browser_spellcheck: true,
                    table_default_attributes: {
                        border: '1',
                        width: '50%',
                        cellspacing: '0'
                    },
                    paste_postprocess: (plugin, args) => {
                        args.node.querySelectorAll('table').forEach(tableNode => {
                            tableNode.setAttribute('border', '1')
                            tableNode.setAttribute('cellspacing', '0')
                        })
                    },
                    content_style: 'body { font-family: Arial; }',
                    remove_linebreaks: false
                }
            },
            otherCrrList: []
        }
    },
    created () {
        if (this.isRestrictedRole) {
            this.tabsEnum = {
                request: 0,
                narrative: 1,
                map: -1,
                mapLoaded: false,
                documents: 2,
                documentsLoaded: false,
                attachments: 3,
                attachmentsLoaded: false,
                eligibility: 4,
                eligibilityLoaded: false,
                qaqc: 5,
                qaqcLoaded: false
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Cultural Property Form', 'mounted, ID: ' + this.$route.params.culturalResourceRecordingId)
        this.loadData()
        if (this.$route.hash === '#eligibility') {
            this.activeTabIndex = this.tabsEnum.eligibility
        }
        if (this.activeTabIndex === 3) {
            this.$refs.siteFormDocuments.loadData()
        }
    },
    watch: {
        activeTabIndex: function (val) {
            loggingService.log(this.isDebug, 'Cultural Resource Recording', 'watch.activeTabIndex: ' + val)
            switch (val) {
            case this.tabsEnum.request: //Request
                break
            case this.tabsEnum.narrative: //Request
                break
            case this.tabsEnum.map:
                if (!this.tabsEnum.mapLoaded) this.$refs.mapx.createMap()
                this.tabsEnum.mapLoaded = true
                break
            case this.tabsEnum.documents:
                if (!this.tabsEnum.documentsLoaded) {
                    this.$refs.siteFormDocuments.loadData()
                    this.$refs.mediaLetter.loadMedia()
                }
                this.tabsEnum.documentsLoaded = true
                break
            case this.tabsEnum.attachments:
                if (!this.tabsEnum.attachmentsLoaded) this.$refs.attachments.loadData()
                this.tabsEnum.attachmentsLoaded = true
                break
            case this.tabsEnum.eligibility:
                //nothing here.  Eligibility is loaded on parent page mount, loadData() method
                break
            case this.tabsEnum.qaqc:
                if (!this.tabsEnum.qaqcLoaded) this.$refs.qaqc.loadQaqcData()
                this.tabsEnum.qaqcLoaded = true
                break
            }
        }
    },
    methods: {
        loadInvestigation (investigationId) {
            if (!investigationId) return true

            return investigationService.get(this.$http, investigationId).then(response => {
                loggingService.log(this.isDebug, 'Cultural Resource Recording', 'loading investigation: ' + investigationId)
                this.investigation = response.data
                projectService.get(this.$http, this.investigation.projectId).then(response2 => {
                    loggingService.log(this.isDebug, 'Cultural Resource Recording', 'loading project:' + this.investigation.projectId)
                    this.project = response2.data
                    return response
                })
            })
        },
        loadCulturalResource (culturalResourceId) {
            loggingService.log(this.isDebug, 'Cultural Resource Recording', 'loading culturalResource: ' + culturalResourceId)
            return culturalResourceService.get(this.$http, culturalResourceId).then(response2 => {
                this.culturalResource = response2.data
                this.culturalResource.propertyTypes = [this.culturalResource.siteTypeId]
                this.culturalResource.timePeriods = [this.culturalResource.timePeriodId]
                this.isSegment = this.culturalResource.segment > 0

                //load CR TRS
                this.loadCulturalResourceTrs()
                //load CR production eligibility
                this.loadEligibility()
            })
        },
        loadSiteSummary (investigationId) {
            var searchDto = {investigationId: investigationId}
            return culturalResourceRecordingService.search(this.$http, searchDto).then(response => {
                //console.log(response.data)
                this.otherCrrList = response.data.filter(x => x.culturalResourceRecordingId !== this.culturalResourceRecordingId)
                //console.log(this.otherCrrList)
                return response
            })
        },
        loadCulturalResourceTrs () {
            if (!this.culturalResource.countyCode) return
            //use gisService to get site trs
            gisService.setGisServiceUrls(this.shpoUserDto.gisToken.token)
            var trsDto = {
                countyCode: this.culturalResource.countyCode,
                siteNumber: this.culturalResource.siteNumber,
                segment: this.culturalResource.segment
            }
            return gisService.siteToTrsQuery(trsDto).then(trsResult => {
                //set trs list and remove duplicates
                this.siteTrsList = trsResult.filter((item, index) => trsResult.indexOf(item) === index).sort()
            })
        },
        loadData () {
            this.culturalResourceRecordingLoading = true
            loggingService.log(this.isDebug, 'Cultural Resource Recording', 'loadData for CRR Id' + this.culturalResourceRecordingId)
            culturalResourceRecordingService.get(this.$http, this.culturalResourceRecordingId).then(response => {
                this.culturalResourceRecording = response.data
                if (this.culturalResourceRecording.siteNarrative) {
                    this.culturalResourceRecording.siteNarrative = this.culturalResourceRecording.siteNarrative.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                if (this.culturalResourceRecording.buildingDescription) {
                    this.culturalResourceRecording.buildingDescription = this.culturalResourceRecording.buildingDescription.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                if (this.culturalResourceRecording.buildingHistory) {
                    this.culturalResourceRecording.buildingHistory = this.culturalResourceRecording.buildingHistory.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
                if (this.isInternalReview) {
                    this.activeTabIndex = 5
                    this.disableRecording = true
                }
                var loadPromises = [this.loadCulturalResource(this.culturalResourceRecording.culturalResourceId),
                    this.loadInvestigation(this.culturalResourceRecording.investigationId)
                ]
                if (this.isNormalization) {
                    loadPromises.push(this.loadSiteSummary(this.culturalResourceRecording.investigationId))
                }
                Promise.all(loadPromises).then(response2 => {
                    // need eligibility component data to load when page loads
                    Promise.all([this.$refs.eligibility.loadData(), this.buildFlags()]).then(response3 => {
                        this.culturalResourceRecordingLoading = false
                    })
                })
            })
        },
        loadEligibility () {
            loggingService.log(this.isDebug, 'Cultural Resource Recording', 'loading current eligibility for ' + this.culturalResource.culturalResourceId)
            //check if site is segment, load normal eligibility if it's not, else load segmentEval component
            //if (!this.isSegment) {
            evaluationService.currentEligibility(this.$http, this.culturalResource.culturalResourceId).then(response => {
                this.currentEval = response.data
                if (this.currentEval) {
                    // var eligibility = evaluationService.EligibilityTypeList.find(x => { return x.eligibilityId === this.currentEval.eligibilityId })
                    // this.currentEval.eligibilityDescription = eligibility ? eligibility.description : ''
                    // var effect = evaluationService.EffectList.find(x => { return x.effectId === this.currentEval.effectId })
                    // this.currentEval.effectDescription = effect ? effect.description : ''
                    // var concurred = evaluationService.ConcurredList.find(x => { return x.concurredId === this.currentEval.concurredId })
                    // this.currentEval.concurredDescription = concurred ? concurred.description : ''
                } else {
                    //create new currentEval
                    this.currentEval = {
                        eligibilityDescription: 'N/A'
                    }
                }
            })
            //}
        },
        // method to determine if qaqc is enabled, runs when workflow has been loaded in siteFormEligibility template
        setWorkflowLoaded () {
            //update qaqc Status
            this.isQaqc = this.$refs.eligibility.isQaqc
            this.isSubmitted = this.$refs.eligibility.isSubmitted
            this.isAgencySubmitted = this.$refs.eligibility.isAgencySubmitted
            this.qaqcEnabled = this.$refs.eligibility.isQaqc && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator, roleService.RoleEnum.ShpoCrApprovingUser])
        },
        workflowOnSubmitSuccess (validationResult) {
            //trigger media letter refresh if letter gen is triggered
            if (validationResult.letterGenTriggered && this.$refs.mediaLetter) {
                this.$refs.mediaLetter.autoRefreshMedia()
            }
        },
        buildFlags () {
            //bitfield for the tabs so we can calc on/off
            var x = 1
            var val = ''
            for (var tabName in this.attachmentTabs) {
                this.attachmentTabs[tabName] = x
                x = x << 1
            }
            for (var propEnum in culturalResourceRecordingService.PropertyTypeEnum) {
                val = culturalResourceRecordingService.PropertyTypeEnum[propEnum]
                if (~(this.culturalResource.propertyTypes.indexOf(val))) {
                    this.propertyFlags[propEnum] = 1
                }
            }
            for (var timeEnum in culturalResourceRecordingService.TimePeriodEnum) {
                val = culturalResourceRecordingService.TimePeriodEnum[timeEnum]
                if (~(this.culturalResource.timePeriods.indexOf(val))) {
                    this.timePeriodsFlags[timeEnum] = 1
                }
            }
        },
        saveSiteNarrative () {
            culturalResourceRecordingService.put(this.$http, this.culturalResourceRecording)
        },
        submit () {
            //Nothing to do
        },
        genSiteFormReport () {
            this.reportLoading = true
            if (this.culturalResourceRecordingId) {
                culturalResourceRecordingService.siteFormReportGen(this.$http, this.culturalResourceRecordingId,
                this.siteTrsList.join(', ')).then(response => {
                    mediaService.saveFileToDownload(response, this.culturalResourceRecording.smithsonianNumber.replace(' ', '') + '_WYCPF.pdf')
                    this.reportLoading = false
                })
            } else {
                this.reportLoading = false
            }
        }
    }
}

</script>

<style>
/* TODO: figure out where to override panel-heading in css file */
.green-bg {
    background: #5f817e !important;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 55px;
  z-index: 1000;
  height: 50px;
  background-color: rgb(194, 194, 178);
  padding: 0 10px;
  color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.sticky ul {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-left: 0;
  height: inherit;
}

.sticky li {
  list-style: none;
  height: 100%;
  line-height: 50px;
}

.sticky li a {
  display: block;
  text-decoration: none;
  color: #263c46;
  height: 100%;
  width: 100%;
  padding: 0 5px;
}

.sticky li a:hover {
  background-color: rgb(194, 194, 178);
  filter: brightness(85%);
}

#overview {
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// CulturalResourceRecording.vue?1e02f6aa